import TherapySideApiService from "./utils/TherapyApi";
import type { PUSH_PLATFORM } from "@/Modules/PushNotifications/Models/constants";
import type {
  CreatePushNotificationQueryApi,
  PushNotificationStatusResponseApi,
  UpdatePushNotificationQueryApi,
} from "@/Modules/PushNotifications/Models/Api";

class PushNotificationsAPIConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getInfo(token: string): Promise<PushNotificationStatusResponseApi> {
    return this.ApiService.get<{ push_token: string }, PushNotificationStatusResponseApi>({
      endpoint: "/v1.0/push-tokens",
      params: { push_token: token },
    });
  }

  createToken(token: string, platform: PUSH_PLATFORM): Promise<PushNotificationStatusResponseApi> {
    return this.ApiService.post<CreatePushNotificationQueryApi, PushNotificationStatusResponseApi>({
      endpoint: "/v1.0/push-tokens",
      body: { push_token: token, platform },
    });
  }

  updateToken(
    token: string,
    platform: PUSH_PLATFORM,
    enable: boolean
  ): Promise<PushNotificationStatusResponseApi> {
    return this.ApiService.patch<UpdatePushNotificationQueryApi, PushNotificationStatusResponseApi>({
      endpoint: "/v1.0/push-tokens",
      body: { push_token: token, platform, enable },
    });
  }

  deleteTokens(token: string, platform: PUSH_PLATFORM): Promise<never> {
    return this.ApiService.delete<CreatePushNotificationQueryApi, never>({
      data: {
        push_token: token,
        platform,
      },
      endpoint: "/v1.0/push-tokens",
    });
  }
}

export default PushNotificationsAPIConnector;
